export default function () {

    if(document.querySelectorAll(".responsive-embed-football-table iframe[data-src]").length > 0) {
        if (window.addEventListener) {
            window.addEventListener("message", function (event) {
                resizeFootballEmbedTable(event.data);
            });
        } else if (window.attachEvent) {
            window.attachEvent("onmessage", function (event) {
                resizeFootballEmbedTable(event.data);
            });
        }
    }
    
    function resizeFootballEmbedTable(data) {
        if(data.message === "footballEmbedTable") {
            let tableIframe = document.querySelector("iframe[data-src='" + data.url + "']");
            if(tableIframe !== null){
                tableIframe.setAttribute("height", data.height + 50);
            }
        }
    }
    
}
